import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from './app/app';
import { store } from './redux/stores/store';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);